import * as React from "react";
import { SportDataGateway, BFFGateway } from "sb-bff-integration";
import { BaseDict } from "./dict";
import { EventListPresenter } from "./ui";
import { EventListPresenterState } from "./state";
import { StaticDecimalLocalizator, CardConfigs, FilterManager } from "../../helpers";
import { Parser } from "../../Parser";
import { Retriever } from "../../Retriever";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { DeviceChangeDispatcherMock } from "sb-resp-utils";
import { Piper } from "../../piper";
import { cmsConfig } from "./config";
let _localMocks;
let EventListOptionsMock, BffGatewayMock, SportDataGatewayMock, deviceChangeDispatcherMock;
if (process.env.NODE_ENV === "development") {
    _localMocks = require("../../mocks/");
    EventListOptionsMock = _localMocks.EventListOptionsMock;
    BffGatewayMock = _localMocks.BffGatewayMock;
    SportDataGatewayMock = _localMocks.SportDataGatewayMock;
}
export class EventListPresenterRoot extends BaseBlock {
    // constructor sets defaults
    constructor(domId, options) {
        super(domId, options);
        let bffGateway, sportsDataGateway;
        if (process.env.NODE_ENV === "development") {
            this.options = EventListOptionsMock;
            bffGateway = new BffGatewayMock();
            sportsDataGateway = new SportDataGatewayMock();
            deviceChangeDispatcherMock = DeviceChangeDispatcherMock.getInstance();
            this.options.navHandler.Navigation = {
                adjustSportsPath: (url) => `en/sports/${url}`,
                getLiveEventLink: (id) => `en/live-betting/#${id}`,
                getLiveBettingLink: () => "en/live-betting"
            };
            this.options.navHandler.OpenLeague = () => { };
            //  bffGateway = new BFFGateway();
            //  sportsDataGateway = new SportDataGateway();
            window["EventListPresenterDATA"] = this.dataProvider;
        }
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            this.options = options;
            bffGateway = new BFFGateway().withBlockId(this.options.cms.BlockId);
            sportsDataGateway = new SportDataGateway();
            StaticDecimalLocalizator.initialize(window["BetFormat"], window["PointsFormat"]);
        }
        this.options.dict = Object.assign(Object.assign({}, BaseDict), (this.options.dict || {}));
        this.options.cms = Object.assign(Object.assign({}, cmsConfig), (this.options.cms || {}));
        let cardConfig = new CardConfigs();
        let filterManager = new FilterManager();
        cardConfig.setConfig(this.options.dataProvider.cardConfiguration, this.options.dataProvider.cardConfigurationEventView);
        this.dataProvider = new EventListPresenterState(new Parser(new Retriever(bffGateway, sportsDataGateway, this.options.dataProvider, cardConfig, filterManager, deviceChangeDispatcherMock), new Piper(this.options.dataProvider.pipeline), this.getAvailableRequestParams(), {
            adjustSportsPath: this.options.navHandler.Navigation.adjustSportsPath,
            adjustLivePath: this.options.navHandler.Navigation.getLiveEventLink
        }, this.options.dataProvider.specialLeagues, {
            topicPrefix: this.options.cms.BlockId,
            clientId: this.options.cms.BetRadarStatisticClientId,
            hasSettlementDate: this.options.cms.hasSettlementDate,
            sortIPTopLeaguesFirst: this.options.cms.SortIPTopLeaguesFirst,
            showStatisticsIcon: this.options.cms.ShowStatisticsIcon,
            isMBNEnabled: this.options.cms.IsMBNEnabled,
            shouldSortEventsByTime: this.options.cms.ShouldSortEventsByTime,
            outrightSortOptions: {
                nameSortSportIds: this.options.cms.NameSortSportIds,
                locale: this.options.cms.Locale
            }
        }, this.options.dict), this.options);
    }
    activate() {
        return super.activate(React.createElement(EventListPresenter, { dataProvider: this.dataProvider, dict: this.options.dict, cms: this.options.cms }));
    }
    beforeActivate() {
        this.dataProvider.activate();
        return this;
    }
    beforeDeactivate() {
        this.dataProvider.deactivate();
        return this;
    }
    setParams(sportId) {
        this.dataProvider.provider.setParams([sportId]);
    }
    getAvailableRequestParams() {
        let sportIds = [], dateRange;
        if (this.options.dataProvider.eventsRequest) {
            sportIds = this.options.dataProvider.eventsRequest.request.ids;
            dateRange = this.options.dataProvider.eventsRequest.request.dateRange;
        }
        else if (this.options.dataProvider.eventsRequestOutrights) {
            sportIds = this.options.dataProvider.eventsRequestOutrights.request.ids;
            dateRange = this.options.dataProvider.eventsRequestOutrights.request.dateRange;
        }
        return {
            sportIds,
            allSportIds: this.options.dataProvider.allSportIds,
            dateRange
        };
    }
}
window["EventListPresenter"] = EventListPresenterRoot;
broadcastBlockLoad("EventListPresenter");
//# sourceMappingURL=index.js.map